import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, ClockIcon } from 'lucide-react';
export function UrgencyBanner() {
  const [spotsTaken, setSpotsTaken] = useState(80);
  const [timeLeft, setTimeLeft] = useState({
    h: 0,
    m: 53,
    s: 20
  });
  useEffect(() => {
    const timer = window.setInterval(() => {
      setTimeLeft(current => {
        const seconds = Math.max(0, current.h * 3600 + current.m * 60 + current.s - 1);
        return {
          h: Math.floor(seconds / 3600),
          m: Math.floor(seconds % 3600 / 60),
          s: seconds % 60
        };
      });
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  useEffect(() => {
    const timer = window.setInterval(() => setSpotsTaken(current => Math.min(current + 1, 94)), 45000);
    return () => window.clearInterval(timer);
  }, []);
  const format = (value: number) => value.toString().padStart(2, '0');
  const time = `${format(timeLeft.h)}:${format(timeLeft.m)}:${format(timeLeft.s)}`;
  return <div className="sticky top-0 z-50 w-full border-b-2 border-brand-gold bg-brand-cinnabar text-white shadow-[0_4px_16px_rgba(36,28,20,0.22)]" data-id="element-364" data-mp="27gau5f7egtkm">
      <div className="mx-auto max-w-7xl px-3 py-2.5 md:px-6" data-id="element-365" data-mp="1xon8juxiy6r2">
        <div className="hidden items-center justify-center gap-5 text-sm md:flex" data-id="element-366" data-mp="1xp6jusso5ww4">
          <span className="flex items-center gap-2" data-id="element-367" data-mp="1srepls4jxyor">
            <ClockIcon className="h-4 w-4 text-brand-goldLight" aria-hidden="true" data-id="element-368" data-mp="2qdc5dhrjrpx0" />
            <span className="font-title text-[11px] uppercase tracking-[0.18em]" data-id="element-369" data-mp="2lehk8963xp9q">
              Precio de lanzamiento cierra en
            </span>
            <span className="rounded-sm bg-black/20 px-2 py-0.5 font-mono font-bold tabular-nums" data-id="element-370" data-mp="2ge3b0nsrs9a4">{time}</span>
          </span>
          <span className="h-4 w-px bg-white/30" aria-hidden="true" data-id="element-371" data-mp="2cfvunu27x9zg" />
          <span className="text-white/90" data-id="element-372" data-mp="1510vlw2epprj">
            <strong className="text-brand-goldLight" data-id="element-373" data-mp="14xwlki29fzsy">{spotsTaken}%</strong> de cupos al precio de lanzamiento tomados
          </span>
          <a href="#comprar" className="inline-flex items-center gap-1.5 rounded-sm bg-brand-goldLight px-3.5 py-1 font-title text-[11px] uppercase tracking-[0.12em] text-brand-woodDark transition-colors duration-150 ease-out hover:bg-white" data-id="element-374" data-mp="12fjonqs68vkx">
            Ver pack
            <ArrowRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-375" data-mp="sjzsd39p3uvn" />
          </a>
        </div>

        <div className="relative overflow-hidden md:hidden" data-id="element-376" data-mp="xijjdi35bwuv">
          <motion.div className="flex w-max items-center gap-5 whitespace-nowrap text-[11px] font-semibold" animate={{
          x: ['0%', '-50%']
        }} transition={{
          duration: 16,
          ease: 'linear',
          repeat: Infinity
        }} data-id="element-377" data-mp="jnqv9v96x8co">
            {[0, 1].map(item => <React.Fragment key={item} data-id="element-378" data-mp="era8b4dq9016">
                <span data-id="element-379" data-mp="eo4jzrcxa26i">
                  Cierra en <strong className="font-mono tabular-nums" data-id="element-380" data-mp="pxscsykgyfa">{time}</strong>
                </span>
                <span aria-hidden="true" data-id="element-381" data-mp="4sknp3ug51h8">·</span>
                <span data-id="element-382" data-mp="4r9l37cqlzrp">
                  <strong className="text-brand-goldLight" data-id="element-383" data-mp="4tvqp1g2i57a">{spotsTaken}%</strong> de cupos tomados
                </span>
                <a href="#comprar" className="rounded-sm bg-brand-goldLight px-2.5 py-1 font-bold uppercase text-brand-woodDark" data-id="element-384" data-mp="3dabllmzswzl8">
                  Ver pack
                </a>
              </React.Fragment>)}
          </motion.div>
        </div>
      </div>
    </div>;
}